import { t, d, A, y, u, G } from "main/jsxRuntime.module";
var _jsxFileName$1 = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/SubscriptionGifts.tsx";
function SubscriptionGifts({
  "product-id": productId,
  "block-id": blockId,
  "title": title = "Free Gifts Included",
  "padding-bottom": paddingBottom = 16,
  "class": className = ""
}) {
  const [gifts, setGifts] = t(d([]), "gifts");
  const [isLoading, setIsLoading] = t(d(true), "isLoading");
  const [error, setError] = t(d(null), "error");
  const [currentFrequency, setCurrentFrequency] = t(d("annually"), "currentFrequency");
  const [currentVariantId, setCurrentVariantId] = t(d(null), "currentVariantId");
  const [giftData, setGiftData] = t(d({}), "giftData");
  const componentRef = t(A(null), "componentRef");
  y(() => {
    const loadProductData = () => {
      try {
        let productData = null;
        if (window.product) {
          productData = window.product;
        } else {
          const productScript = document.querySelector("[data-product-json]");
          if (productScript == null ? void 0 : productScript.textContent) {
            productData = JSON.parse(productScript.textContent);
          }
        }
        if (!productData || !productData.variants) {
          setError("Product data not available");
          setIsLoading(false);
          return;
        }
        const metafieldsContainer = document.querySelector("[data-subscription-gifts-metafields]");
        if (metafieldsContainer) {
          const giftDataMap = {};
          productData.variants.forEach((variant) => {
            const variantScript = metafieldsContainer.querySelector(`script[data-variant-id="${variant.id}"]`);
            if (variantScript == null ? void 0 : variantScript.textContent) {
              try {
                giftDataMap[variant.id.toString()] = JSON.parse(variantScript.textContent);
              } catch (error2) {
                console.warn(`Failed to parse gift data for variant ${variant.id}:`, error2);
              }
            }
          });
          setGiftData(giftDataMap);
        }
        const firstVariant = productData.variants[0];
        if (firstVariant) {
          setCurrentVariantId(firstVariant.id.toString());
        }
        setIsLoading(false);
      } catch (error2) {
        console.error("Error loading subscription gifts data:", error2);
        setError("Failed to load gift data");
        setIsLoading(false);
      }
    };
    loadProductData();
  }, []);
  y(() => {
    if (!currentVariantId || !giftData[currentVariantId]) {
      setGifts([]);
      return;
    }
    const variantGifts = giftData[currentVariantId];
    const frequencyKey = currentFrequency === "annually" ? "annual_gifts" : currentFrequency === "quarterly" ? "quarterly_gifts" : "monthly_gifts";
    setGifts(variantGifts[frequencyKey] || []);
  }, [currentVariantId, currentFrequency, giftData]);
  const getCurrentVariantId = () => {
    if (window.product && window.product.selected_or_first_available_variant) {
      return window.product.selected_or_first_available_variant.id.toString();
    }
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      return variantInput.value;
    }
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      return variantSelect.value;
    }
    const selectedMembershipVariant = document.querySelector(".membership-variant-option.selected, .membership-variant-option:checked");
    if (selectedMembershipVariant) {
      const variantId = selectedMembershipVariant.getAttribute("data-variant-id") || selectedMembershipVariant.getAttribute("value") || selectedMembershipVariant.dataset.variantId;
      if (variantId) return variantId;
    }
    const variantRadio = document.querySelector('input[type="radio"][name*="variant"]:checked, input[type="radio"][data-variant-id]:checked');
    if (variantRadio) {
      const variantId = variantRadio.getAttribute("data-variant-id") || variantRadio.value;
      if (variantId) return variantId;
    }
    return null;
  };
  const getSelectedFrequency = () => {
    const savedFrequency = sessionStorage.getItem("selected-frequency");
    if (savedFrequency && ["annually", "quarterly", "monthly"].includes(savedFrequency)) {
      return savedFrequency;
    }
    const activeFrequencyRadio = document.querySelector('input[name="selling_plan"]:checked');
    if (activeFrequencyRadio) {
      const frequencyValue = activeFrequencyRadio.getAttribute("data-frequency");
      if (frequencyValue && ["annually", "quarterly", "monthly"].includes(frequencyValue)) {
        return frequencyValue;
      }
    }
    return "annually";
  };
  const updateFromDOM = () => {
    const newVariantId = getCurrentVariantId();
    const newFrequency = getSelectedFrequency();
    if (newVariantId !== currentVariantId) {
      setCurrentVariantId(newVariantId);
    }
    if (newFrequency !== currentFrequency) {
      setCurrentFrequency(newFrequency);
    }
  };
  y(() => {
    const handleChange = (event) => {
      const target = event.target;
      if (target.matches('input[name="selling_plan"]')) {
        setTimeout(updateFromDOM, 100);
      }
      if (target.matches('input[name="id"], select[name="id"], .membership-variant-option, input[data-variant-id], input[type="radio"][name*="variant"]')) {
        setTimeout(updateFromDOM, 100);
      }
    };
    const handleClick = (event) => {
      const target = event.target;
      if (target.matches(".membership-variant-option, [data-variant-id]")) {
        setTimeout(updateFromDOM, 150);
      }
    };
    const handleThemeVariantChange = () => {
      setTimeout(updateFromDOM, 100);
    };
    const handleCustomVariantChange = () => {
      setTimeout(updateFromDOM, 100);
    };
    document.addEventListener("change", handleChange);
    document.addEventListener("click", handleClick);
    document.addEventListener("theme:variant:change", handleThemeVariantChange);
    window.addEventListener("variantChange", handleCustomVariantChange);
    setTimeout(updateFromDOM, 500);
    return () => {
      document.removeEventListener("change", handleChange);
      document.removeEventListener("click", handleClick);
      document.removeEventListener("theme:variant:change", handleThemeVariantChange);
      window.removeEventListener("variantChange", handleCustomVariantChange);
    };
  }, [currentVariantId, currentFrequency]);
  const renderGiftCard = (gift) => u("div", {
    className: "rs-bg-white rs-relative rs-w-full rs-flex rs-flex-col rs-gap-2",
    "data-name": "Product Card Small",
    children: [u("div", {
      className: "rs-box-border rs-flex rs-flex-row rs-gap-2 rs-items-center rs-justify-start rs-py-2.5 rs-px-2 rs-relative rs-w-full",
      children: [u("div", {
        className: "rs-bg-center rs-bg-cover rs-bg-no-repeat rs-h-[100px] md:rs-h-[146px] rs-overflow-hidden rs-shrink-0 rs-w-[80px] md:rs-w-[120px] rs-rounded-none",
        "data-name": "Image",
        style: {
          backgroundImage: gift.featured_image ? `url(${gift.featured_image})` : "none"
        },
        children: !gift.featured_image && u("div", {
          className: "rs-w-full rs-h-full rs-bg-gray-100 rs-flex rs-items-center rs-justify-center",
          children: u("div", {
            className: "rs-text-gray-400 rs-text-xs",
            children: "No image"
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 266,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 265,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1,
        lineNumber: 259,
        columnNumber: 9
      }, this), u("div", {
        className: "rs-basis-0 rs-box-border rs-flex rs-flex-col rs-gap-[15px] rs-grow rs-items-start rs-justify-start rs-min-h-px rs-min-w-px rs-p-0 rs-relative rs-shrink-0",
        "data-name": "Product Info",
        children: u("div", {
          className: "rs-capitalize rs-font-normal rs-leading-[0] rs-not-italic rs-relative rs-shrink-0 rs-text-black rs-text-[22px] rs-text-left rs-tracking-[-0.66px]",
          children: u("p", {
            className: "rs-block rs-leading-[1.2] rs-break-words",
            children: gift.title
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 275,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$1,
          lineNumber: 274,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$1,
        lineNumber: 270,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$1,
      lineNumber: 258,
      columnNumber: 7
    }, this), u("div", {
      "aria-hidden": "true",
      className: "rs-absolute rs-border-[0.812px] rs-border-black/30 rs-border-solid rs-inset-0 rs-pointer-events-none"
    }, void 0, false, {
      fileName: _jsxFileName$1,
      lineNumber: 279,
      columnNumber: 7
    }, this)]
  }, gift.id, true, {
    fileName: _jsxFileName$1,
    lineNumber: 253,
    columnNumber: 5
  }, this);
  if (isLoading || error || !gifts || gifts.length === 0) {
    return null;
  }
  return u("div", {
    ref: componentRef,
    className: `subscription-gifts-block rs-w-full ${className}`,
    style: {
      paddingBottom: `${paddingBottom}px`
    },
    "data-subscription-gifts-block": true,
    "data-block-id": blockId,
    children: [title && u("h3", {
      className: "subscription-gifts__title rs-font-tertiary rs-text-[12px] rs-text-black rs-tracking-[-0.6px] rs-leading-[0.9] rs-capitalize rs-mb-[32px] lg:rs-mb-[22px]",
      children: title
    }, void 0, false, {
      fileName: _jsxFileName$1,
      lineNumber: 300,
      columnNumber: 9
    }, this), u("div", {
      className: "subscription-gifts__content rs-bg-white rs-relative rs-w-full rs-flex rs-flex-col rs-gap-[18px] lg:rs-gap-[22px]",
      children: gifts.map(renderGiftCard)
    }, void 0, false, {
      fileName: _jsxFileName$1,
      lineNumber: 305,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$1,
    lineNumber: 292,
    columnNumber: 5
  }, this);
}
var _jsxFileName = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/entrypoints/subscription-gifts.tsx";
class SubscriptionGiftsElement extends HTMLElement {
  constructor() {
    super(...arguments);
    this.initialized = false;
  }
  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;
      const productId = this.getAttribute("product-id") || "";
      const blockId = this.getAttribute("block-id") || "";
      const title = this.getAttribute("title") || "Free Gifts Included";
      const paddingBottom = parseInt(this.getAttribute("padding-bottom") || "16", 10);
      const className = this.getAttribute("class") || "";
      G(u(SubscriptionGifts, {
        "product-id": productId,
        "block-id": blockId,
        title,
        "padding-bottom": paddingBottom,
        class: className
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }, this), this);
    }
  }
  disconnectedCallback() {
    this.initialized = false;
    G(null, this);
  }
  // Handle attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue && this.initialized) {
      this.connectedCallback();
    }
  }
  // Define which attributes to observe
  static get observedAttributes() {
    return ["product-id", "block-id", "title", "padding-bottom", "class"];
  }
}
customElements.define("subscription-gifts", SubscriptionGiftsElement);
